// @ts-nocheck
import React, { useState, useEffect } from "react";
import { createStore, applyMiddleware, compose } from "redux";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import intl from "react-intl-universal";

import reduxThunk from "redux-thunk";
import { BrowserRouter as Router } from "react-router-dom";
import MenuLayout from "./pages/menuLayout";
import reducer from "./reducers";
import { appLocales, antdLocales } from "./config/locales";
import emit from "@/utils/emit";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(reduxThunk))
);

function App() {
  const [antdLang, setAntdLang] = useState<any>(antdLocales.zh_CN);
  const [initLocaleDone, setInitLocaleDone] = useState<boolean>(false);

  const loadLocales = (lang = "zh_CN", reload = false) => {
    intl
      .init({
        currentLocale: lang,
        locales: appLocales,
      })
      .then(() => {
        setAntdLang(antdLocales[lang]);
        localStorage.setItem("lang", lang);
        setInitLocaleDone(true);
        if (reload) {
          window.location.reload();
        }
      });
  };

  useEffect(() => {
    emit.on("change_language", (lang: string) => {
      if (!lang) {
        return;
      }
      loadLocales(lang, true);
    });

    const localLang = localStorage.getItem("lang");
    if (localLang && localLang !== "null") {
      loadLocales(localLang);
      return;
    }

    // 获取浏览器语言
    let language =
      navigator.language ||
      navigator.userLanguage ||
      navigator.browserLanguage ||
      "en_US";
    language = language.replace("-", "_");
    if (language === "zh_CN" || language === "en_US") {
      loadLocales(language);
    } else {
      loadLocales("en_US");
    }
  }, []);

  return (
    initLocaleDone && (
      <ConfigProvider locale={antdLang}>
        <Router>
          <Provider store={store}>
            <MenuLayout />
          </Provider>
        </Router>
      </ConfigProvider>
    )
  );
}

export default App;
